<template>
  <div class="steps">
    <template v-for="(step, index) in steps">
      <div @click="updateActive(index)" :class="['step', active === index ? 'active' : '', index < active ? 'past' : '']"><span class="number">{{index + 1}}</span> {{ step }}</div>
      <div v-if="index + 1 !== steps.length" class="separator"></div>
    </template>
  </div>
</template>

<style scoped>
.separator{
  flex: 1;
  background-color: #dedede;
  height: 1px;
  margin: 0 24px;
}

.steps {
  display: flex;
  flex-direction: column;
  margin: clamp(16px, 2.222vw, 32px) 0;

}

@media (min-width: 500px) {
  .steps {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin: 32px 0;
  }
}

.steps .step {
  display: flex;
  align-items: center;
  cursor: not-allowed;
  line-height: 1;
  background: #e9e9e9;
  border-radius: 10px;
  padding-right: 10px;
  font-size: 14px;
  position: relative;
  margin-bottom: 8px;
}

.steps .step.past, .steps .step.active {
  cursor: pointer;
}

.steps .number {
  background-color: #919191;
  height: 20px;
  width: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  border-radius: 50%;
  display: inline-block;
  color: #fff;
  font-weight: bold;
  margin-right: 8px;
}

.steps .step.active .number {
  background-color: #E12A12;
}

.steps .step.active {
  background-color: #e22a13;
  color: #fff;
}

.steps .step.past .number, .steps .step.past {
  background-color: #dc7f72;
  color: #fff;
}
</style>

<script>
export default {
  components: {},
  emits: ['update:active'],
  props: {
    steps: Array,
    active: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({

  }),
  methods: {
    updateActive: function (value) {
      if(value < this.active){
        this.$emit('update:active', value);
      }
    }
  }
}
</script>
